import { useState, useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CatLoader from "./components/base/CatLoader";
import { useSiteSettings } from "./hooks/useSiteSettings";

function App() {
  const { settings } = useSiteSettings();
  const [delayDone, setDelayDone] = useState(false);

  const delayMs = settings?.initialDelayMs ?? 5000;

  useEffect(() => {
    const timer = setTimeout(() => {
      setDelayDone(true);
    }, delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  // Page titles are managed per route by the SEO component. Only the favicon
  // belongs to the global site settings.
  useEffect(() => {
    if (settings?.faviconUrl) {
      let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = settings.faviconUrl;
    }
  }, [settings?.faviconUrl]);

  if (!delayDone) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <CatLoader message="Preparando a casinha dos gatinhos..." />
      </div>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
